/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import {
  getAlleleFrequency,
  cropNumber,
} from "../../../common/helpers/helpers";
import HelperText from "../HelperText";

const MultipleWithLabelAndHelpText = ({
  item,
  prop,
  label,
  crop = false,
  isAf = false,
}) => {
  if (Array.isArray(item[prop]) && item[prop].length > 0) {
    return (
      <div className="varsome-horiz-list-item">
        <div className="varsome-horiz-list-label">
          {label}
          <HelperText fieldDescriptionKey={label} />
        </div>
        {item[prop].map((i, j) => {
          return (
            <div
              className="varsome-horiz-list-value"
              data-testid={`${label}-value-${j}`}
              key={j}
            >
              {crop && isAf ? getAlleleFrequency(i) : crop ? cropNumber(i) : i}
            </div>
          );
        })}
      </div>
    );
  }
  return null;
};

MultipleWithLabelAndHelpText.propTypes = {
  item: PropTypes.shape({}).isRequired,
  prop: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  crop: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  isAf: PropTypes.bool,
};

export default MultipleWithLabelAndHelpText;
